export default {
  setNumMerchants(state, { numMerchants }) {
    state.numMerchants = numMerchants
  },
  setCurrentMerchant(state, { merchant }) {
    state.currentMerchant = merchant
  },
  setMerchantLoading(state, { loading }) {
    state.merchantLoading = loading
  },
  setMerchantPage(state, { merchants }) {
    state.merchants = merchants
    state.merchantLoading = false
  },
  setNumCustomers(state, { numCustomers }) {
    state.numCustomers = numCustomers
  },
  setCustomerLoading(state, { loading }) {
    state.customerLoading = loading
  },
  setCustomerPage(state, { customers }) {
    state.customers = customers
    state.customerLoading = false
  },
  setNumAccounts(state, { numAccounts }) {
    state.numAccounts = numAccounts
  },
  setAccountLoading(state, { loading }) {
    state.accountLoading = loading
  },
  setAccountPage(state, { accounts }) {
    state.accounts = accounts
    state.accountLoading = false
  },
  setTransactionReportURL(state, { reportURL }) {
    state.transactionReportURL = reportURL
  },
  setPageTitle(state, { pageTitle }) {
    state.pageTitle = pageTitle
  },
  setCSVData(state, data) {
    state.csvData = data
  }
}
